import React, { FC, useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Alert, Row } from "antd";
import { useStores } from "../store";
import { MentionsInput, Mention } from "react-mentions";
import { getCurrentID } from "../utils/helpers";
import { __ } from "../utils";
import { TodoItem } from "./todoItem";
import { LoadingOutlined } from "@ant-design/icons";
import mentionInputStyle from "./mentionInputStyle";
import mentionListStyle from "./mentionListStyle";
import "../style/metabox.scss";

/* istanbul ignore next: Example implementations gets deleted the most time after plugin creation! */
const MetboxComponent: FC<{}> = observer(() => {
    const { userStore, todoStore } = useStores();
    const [value, setValue] = useState("");
    const [displayTip, setDisplayTip] = useState(false);
    const [mentioned, setMetioned] = useState([]);

    useEffect(() => {
        todoStore.getTodos({
            entity_id: getCurrentID()
        });
    }, []);

    const handleSubmit = () => {
        const mentions = mentioned.map((mention) => mention.id);
        todoStore.addTodo(value, mentions);
        setValue("");
        //if (displayTip) {
        //setDisplayTip(false);
        //}
        displayTip ? setDisplayTip(false) : setDisplayTip(true);
        setMetioned([]);
    };

    const fetchUsers = (query: string, callback: any) => {
        userStore.getUsers(query);
        return userStore.users;
    };

    const handleChange = (event: any, newValue: string, newPlainTextValue: string, mentions: []) => {
        setValue(newValue);
        setMetioned(mentions);
    };

    const checkSumbit = (event: any) => {
        if (event.ctrlKey && event.key === "Enter") {
            handleSubmit();
            setDisplayTip(false);
        }
    };

    const getPlaceHolder = (): string => {
        return getCurrentID()
            ? "Mention user by typing `@`"
            : "Cannot add any todo item before having this post created";
    };

    return (
        <div className="wp-styleguide">
            <ul>
                {todoStore.todos.map((t) => (
                    <TodoItem key={t.id} todo={t} />
                ))}
                {!todoStore.todos.length && !todoStore.loading ? __("No entries") : ""}
            </ul>
            {todoStore.loading && <LoadingOutlined />}
            {todoStore.errors.length > 0 &&
                todoStore.errors.map((m, index) => <Alert key={index} message={m} type={todoStore.errorType} />)}
            <MentionsInput
                value={value}
                onChange={handleChange}
                disabled={!getCurrentID()}
                className="mentions-input"
                style={mentionListStyle}
                placeholder={getPlaceHolder()}
                onKeyDown={checkSumbit}
                allowSuggestionsAboveCursor={true}
            >
                <Mention
                    trigger="@"
                    data={fetchUsers}
                    style={mentionInputStyle}
                    markup='<span style="background-color:#cee4e5" data-id="__id__">@__display__</span>'
                />
            </MentionsInput>
            <div className="metabox-footer">
                <Row justify="end">
                    {displayTip && (
                        <span>
                            Tip: <span className="todo-tooltip">Ctrl + Enter</span> to add &nbsp;
                        </span>
                    )}
                    <button type="button" className="button add-todo" onClick={handleSubmit}>
                        {__("Add")}
                    </button>
                </Row>
            </div>
        </div>
    );
});

export { MetboxComponent };
